import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { formatCityStateAndCountry } from "~utils/formatting-helpers"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
} from "~graphql/generated/graphql"
import ListingTypePill from "~components/pages/listing/listing-title/listing-type-pill"
import ListingLicensePill from "~components/pages/listing/listing-title/listing-license-pill"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly listing: PublicListingFieldsFragment | ListingFieldsFragment
}

export default function ListingTitleInfoBox({ listing }: Props) {
    const styles = useStyles()
    const cityStateAndCountry = formatCityStateAndCountry(listing.location)

    return (
        <Box style={styles.root}>
            <Box style={styles.infoBoxTop}>
                <ListingTypePill type={listing.type} />
                <ListingLicensePill
                    listingType={listing.type}
                    licenseRequired={listing.license_required}
                />
            </Box>
            <Box style={styles.location}>{cityStateAndCountry}</Box>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: "flex",
            flexDirection: { base: "column", md: "row" },
            alignItems: { base: "start", md: "center" },
            fontSize: { base: "14px", md: "15px" },
            fontWeight: 300,
            gap: "8px",
        },
        infoBoxTop: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2px",
            padding: { base: "12px 0 12px 0", md: "0" },
        },
        location: {
            fontWeight: 600,
            textDecoration: "underline",
        },
    })
}
